<osp-button
  [category]="'ghost'"
  (onClick)="handleClick()"
  [label]="'modules.notification.markAllAsRead' | translate"
  [disabled]="$disabled()"
  [loading]="$loading()"
/>
